<template>
  <v-app>
    <!-- �����C -->
    <Appbar />

    <!-- ����API�ɰʵe -->
    <Loading />

    <!-- �T���� -->
    <Alert />

    <!-- ��ܮ� -->
    <Dialog />

    <v-main class="MainColor">
      <router-view v-if="isRouterAlive" />
    </v-main>
  </v-app>
</template>
<style lang="scss">
.v-data-table .v-data-table-header tr th {
  font-size: 16px !important;
  white-space: nowrap;
  // border-right: #dbdbdb 1px solid;
}
.v-data-table td {
  font-size: 16px !important;
  white-space: nowrap;
}
tbody tr:nth-of-type(odd) {
  background-color: white;
}

tbody tr:nth-of-type(even) {
  background-color: rgb(245, 245, 245);
}
.MainColor {
  background-color: rgb(245, 249, 253);
}
</style>
<script>
//����
import Appbar from "./components/AppBar.vue";
import Loading from "./components/Loading.vue";
import Alert from "./components/Alert.vue";
import Dialog from "./components/Dialog.vue";
//style
import "@/assets/css/style.scss";

export default {
  name: "App",
  components: {
    Appbar,
    Loading,
    Alert,
    Dialog,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data: () => ({
    isRouterAlive: true,
  }),

  methods: {
    //���s���J
    reload() {
      console.log("reload!");
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    onKeyPress(e) {
      console.log(e.keyCode);
      if (this.$route.path.toLowerCase() == "/login") return;

      if (e.keyCode === 13) {
        e.target.blur();
      }
    },
  },
  mounted() {
    window.addEventListener("keypress", this.onKeyPress);
  },
};
</script>
